<template>
	<div class="first-visit-detail">
		<!-- 页面标题 -->
<!--		<div class="page-title">{{ survey.title }}</div>-->
		<div class="content-wrapper">
			<!-- 一、患者基本信息（文档表格样式） -->
			<div class="section">
				<h3 class="section-title">患者基本信息</h3>
				<table class="info-table">
					<tr class="info-tr">
						<td class="info-td">患者姓名</td>
						<td class="info-td">{{inWardFromData.patientName}}</td>
					</tr>
					<tr class="info-tr">
						<td class="info-td">住院号</td>
						<td class="info-td">{{inWardFromData.patid}}</td>
					</tr>
					<tr class="info-tr">
						<td class="info-td">入院日期</td>
						<td class="info-td">{{inWardFromData.inHosTime}}</td>
					</tr>
					<tr class="info-tr">
						<td class="info-td">科室/病区</td>
						<td class="info-td">{{inWardFromData.inWard}}</td>
					</tr>
					<tr class="info-tr">
						<td class="info-td">主管医生</td>
						<td class="info-td">{{inWardFromData.inNurse}}</td>
					</tr>
					<tr class="info-tr">
						<td class="info-td">探访日期</td>
						<td class="info-td">{{ dayjs().format('YYYY-MM-DD') }}</td>
					</tr>
<!--					<tr class="info-tr">-->
<!--						<td class="info-td">个案管理师</td>-->
<!--						<td class="info-td">{{user.realname}}</td>-->
<!--					</tr>-->
				</table>
			</div>
      <template v-if="!spinner">
        <div style="width: 100%;overflow: hidden;">
          <van-form>
            <template v-for="(topic, index) in survey.topics">
              <topic
                  :item="topic"
                  :level="0"
                  :num="index+1"
                  @update:radioValue="handleRadioUpdate"
              />
            </template>
          </van-form>
        </div>
        <!-- 提交按钮 -->
        <div class="submit-btn-container">
          <div class="submit-btn-ok">
            <van-button type="primary" size="large" @click="submitSurvey">提交</van-button>
          </div>
          <div class="submit-btn-clear">
            <van-button type="danger" size="large" @click="$router.go(-1)">取消</van-button>
          </div>
        </div>
      </template>
      <template v-else>
        <van-loading type="spinner" />
      </template>
		</div>
	</div>
</template>

<script>
import dayjs from 'dayjs';
import topic from './components/topic.vue';
import { visitSurveyInfo, visitSurveyAdd } from '@/request/visit_survery';
import { CRM_API } from '@/request/crm';
import Vue from "vue";
import TYPES from "@/constant/types.js";

export default {
	name: "index",
	components: {
		topic
	},
	data() {
		return {
      spinner: true,
      data: [],
			survey: {},
      inWardFromData: {},
      user: {
        realname: ''
      }
		};
	},
	created() {
    this.spinner = true
    const {loadData} = this
    loadData().then(res => {
      this.spinner = false
      return res
    })
	},
	methods: {
    localStorage() {
      const apply_id = this.$route.query.id
      const key = `visitSurveyHospitalApplyData_${apply_id}`
      let inWardFrom = this.$store.getters.visitSurveyHospitalApplyData
      if ((typeof inWardFrom === 'object' && Object.keys(inWardFrom).length === 0) || !inWardFrom) {
        inWardFrom = localStorage.getItem(key)
        inWardFrom = JSON.parse(inWardFrom)
      }
      localStorage.setItem(key, JSON.stringify(inWardFrom))
      this.inWardFromData = inWardFrom
      return inWardFrom
    },
    loadData () {
      const {set_survey_data, chunk_data, set_form_data, set_init_form, set_init_form_item, localStorage, user} = this
      set_init_form()

      const inWardFrom = localStorage()
      return visitSurveyInfo({"id": "690affbba344f82a5d0bdbdc", patientId: inWardFrom.patientId}).then(res => {
        user.realname = res.result.user.realname
        set_survey_data(res.result.questionnaire)
        chunk_data()

        const zdmc = (res.result.apply || {zdmc: ''}).zdmc.split(',')[0]
        const form_data = set_init_form_item('$zdmc', zdmc)
        set_form_data(res.result.answer || undefined, form_data)
        return res
      })
    },
    set_init_form () {
      this.$store.dispatch("setFirstVisitSurveyFormData", {})
    },
    set_init_form_item(key, val) {
      const rows = this.$store.getters.visitSurveyTopicRows
      const zdmc_item = rows.find(item => {return item.value === key})

      const form_data = this.$store.getters.visitSurveyFormData
      form_data[`${zdmc_item.id}`] = val
      this.$store.dispatch("setFirstVisitSurveyFormData", form_data)
      return form_data
    },
    set_form_data(res, form_data) {
      if (!res) {
        this.$store.dispatch("setFirstVisitSurveyFormData", form_data)
        return
      }

      const data = res.data
      for (const item of data) {
        if (typeof item.value === 'object') {
          if (Array.isArray(item.value)) {
            form_data[item.id] = item.value.map(v => {
              if (typeof v.value === 'object' && v.value.values) {
                for (let i = 0; i < v.value.values.length; i++) {
                  form_data[`other_${v.id}_${i}`] = v.value.values[i]
                }
              }
              return v.id
            })
          } else if (item.value.type === 'option') {
            form_data[item.id] = item.value.id
            if (typeof item.value.value === 'object' && item.value.value.values) {
              for (let i = 0; i < item.value.value.values.length; i++) {
                form_data[`other_${item.value.id}_${i}`] = item.value.value.values[i]
              }
            }
          } else if (item.value.type === 'text') {
            form_data[item.id] = item.value.value
          }
        }
      }
      this.$store.dispatch("setFirstVisitSurveyFormData", form_data)
    },
    set_survey_data(data) {
      this.survey = data
    },
    chunk_data() {
      this.data = []
      for (let i = 0; i < this.survey.topics.length; i++) {
        const data = this.son(this.survey.topics[i]);
        this.data.push(data)
      }
      this.$store.dispatch("setFirstVisitSurveyTopicRows", this.data)
    },
    son(item) {
      const rows = item.items

      for (let i = 0; i < rows.length; i++) {
        const data = this.son(rows[i]);
        this.data.push(data)
      }

      const tmp = JSON.parse(JSON.stringify(item))
      tmp.items = []
      return tmp
    },
		dayjs,
		// 接收单选状态更新
		handleRadioUpdate({ groupId, value }) {
			this.answers.radio[groupId] = value;
		},
    filterFormItems(values) {
      const {data} = this
      return values.map((value) => {
        const tmp = data.find(obj => obj.id === value)
        return tmp ? {id: tmp.id, value: tmp.title, type: 'option'} : undefined
      }).filter(obj => obj)
    },
    filterFormItem(id, value) {
      const {data} = this
      const tmp = data.find(obj => obj.id === value)
      if (tmp) {
        return tmp ? {id: tmp.id, value: tmp.title, type: 'option'} : undefined
      }

      if (typeof value === 'string') {
        return {id: id, value: value, type: 'text'}
      }
      return undefined
    },
    joinOtherValue(val, item) {
      let tmp_value = ''
      if (val.indexOf("$input") !== -1) {
        const rows = val.split('$input')
        for (let j = 0; j < rows.length; j++) {
          const tmp = !item? '': (item[j]? item[j]: '')
          tmp_value += rows[j] + tmp
        }
        return {text: tmp_value, values: item}
      }
      return val
    },
		// 提交问卷（对接后端接口）
    async submitSurvey() {
      const form_data = this.$store.getters.visitSurveyFormData
      const required_data = this.data.filter((item) => item.required)

      let is_passed = true
      for (let i = 0; i < required_data.length; i++) {
        const item = required_data[i]
        if (!form_data[item.id]) {
          alert(`请完善${item.title}`);
          is_passed = false
          break
        }
      }

      if (!is_passed) {
        return false;
      }
      const submit_data = []
      const submit_item = {}
      const {data, filterFormItems, filterFormItem, joinOtherValue} = this
      for (let key in form_data) {
        if (key.indexOf('other') === -1) {
          const item = data.find(item => item.id.toString() === key.toString())
          if (!item) {
            continue
          }
          const tmp_item = {id: key, title: item.title}
          if (form_data[key] && typeof form_data[key] === 'object' && Array.isArray(form_data[key])) {
            tmp_item['value'] = filterFormItems(form_data[key])
          } else {
            tmp_item['value'] = filterFormItem(key, form_data[key])
          }
          submit_data.push(tmp_item)
        } else {
          const tmp_list = key.split('_')
          if (!submit_item[tmp_list[1]]) {
            submit_item[tmp_list[1]] =[form_data[key]]
          } else {
            submit_item[tmp_list[1]].push(form_data[key])
          }
        }
      }
      for (const item of submit_data) {
        const obj = item.value
        if (Array.isArray(obj)) {
          obj.map((v) => {
            v.value = joinOtherValue(v.value, submit_item[v.id])
            return v
          })
        } else {
          obj.value = joinOtherValue(obj.value, submit_item[obj.id])
        }
      }
      const {toastSuccess, routerPush, localStorage} = this
      const inWardFrom = localStorage()

      if(!await this.submitTags(inWardFrom.patientId, submit_data)) {
        return false
      }

      const { code } = await visitSurveyAdd({applyId: this.$route.query.id, idCard: inWardFrom.idCard, patientId: inWardFrom.patientId, data: submit_data})
      if (code === 200) {
        toastSuccess('提交成功')
        routerPush('/crm/detail-hospital', inWardFrom)
      }
      return true
		},
    // 提交标签
    async submitTags(patientId, data) {
      const tag_list = []
      const tags = (Vue.ls.get(TYPES.UI_CACHE_DB_DICT_DATA) || {patient_tag: []}).patient_tag
      for (const item of data) {
        if (Array.isArray(item.value)) {
          const rows_1 = item.value.filter(v => typeof v.value !== 'object')
          const rows_2 = item.value.filter(v => typeof v.value === 'object')
          if (item.id === '7377155017444302867') {
            // PICC
            if(rows_1.find(v => v.value.indexOf('PICC') !== -1)) {
              const tag = tags.find(tag => tag.text === 'PICC')
              if (tag) {
                tag_list.push(tag.value)
              }
            }
            // 输液港
            if(rows_1.find(v => v.value.indexOf('输液港') !== -1)) {
              const tag = tags.find(tag => tag.text === '输液港')
              if (tag) {
                tag_list.push(tag.value)
              }
            }
            // 其他导管
            if(rows_2.find(v => v.value.text.indexOf('其他') !== -1)) {
              const tag = tags.find(tag => tag.text === '其他导管')
              if (tag) {
                tag_list.push(tag.value)
              }
            }
          }

        } else {
          // 病情保密
          if (item.id === '7377155017473662977' && item.value.id === '7377155017473662980') {
            const tag = tags.find(tag => tag.text === '病情保密')
            if (tag) {
              tag_list.push(tag.value)
            }
          }

          // 疼痛
          if (item.title.indexOf('疼痛') !== -1) {
            if(item.value.value.text.indexOf('有') !== -1) {
              const tag = tags.find(tag => tag.text === '疼痛管理')
              if (tag) {
                tag_list.push(tag.value)
              }
            }
          }
        }

      }

      if (tag_list.length < 1) {
        return true
      }

      const { code } = await CRM_API.crmPatientEditTag({ id: patientId, tag: tag_list.join(',') })
      if ( code !== 200 ) {
        this.$toast.error('患者标签保存失败！')
        return false
      }

      return true
    },
    toastSuccess(msg) {
      this.$toast.success(msg)
    },
    routerPush (url, query) {
      this.$router.push({path: url, query: query})
    },
	}
};
</script>

<style scoped lang="less">
/* 1. 全局滚动基础配置 */
::v-deep html,
::v-deep body {
	overflow: hidden !important; /* 禁止body滚动，避免双滚动条 */
	height: 100vh !important;   /* 让body占满屏幕高度 */
	margin: 0;
	padding: 0;
}

.first-visit-detail {
	padding: 0; /* 取消外层 padding，避免滚动区域偏移 */
	background-color: #fff;
	font-family: "Microsoft YaHei", sans-serif;
	height: 100vh; /* 让主容器占满屏幕高度 */

	.page-title {
		font-size: 30px;
		font-weight: 700;
		color: #333;
		padding: 15px 0; /* 用padding替代margin，避免影响滚动 */
		text-align: center;
		border-bottom: 1px solid #eee; /* 增加下划线，区分标题与内容 */
	}

	/* 2. 核心滚动容器：内容超出时显示滚动条 */
	.content-wrapper {
		height: calc(100vh - 70px); /* 屏幕高度 - 标题高度（70px）= 滚动区域高度 */
		overflow-y: auto;         /* 垂直方向超出时显示滚动条 */
		overflow-x: hidden;       /* 禁止水平滚动，避免布局错乱 */
		padding: 0 20px;          /* 内部 padding，保持内容边距 */
		scrollbar-width: thin;    /* 优化滚动条宽度（适配Firefox） */

		/* 美化滚动条（适配Chrome/Safari） */
		&::-webkit-scrollbar {
			width: 8px; /* 滚动条宽度 */
		}
		&::-webkit-scrollbar-thumb {
			background-color: #ccc; /* 滚动条滑块颜色 */
			border-radius: 4px;    /* 滚动条圆角 */
		}
		&::-webkit-scrollbar-track {
			background-color: #f5f5f5; /* 滚动条轨道颜色 */
		}
	}

	/* 3. 优化章节样式：移除可能的高度限制 */
	.section {
		margin-bottom: 20px; /* 减少底部间距，避免内容过于分散 */
		padding: 15px;
		border: 1px solid #eee;
		border-radius: 8px;
		background-color: #fff;
		/* 关键：删除任何固定高度/最大高度限制，让内容自然展开 */
		height: auto !important;
		max-height: none !important;
	}
	/* 患者信息表格（文档样式） */
	.section-title {
		font-size: 32px;
		font-weight: 550;
		text-align: left;
		color: #5f5aa2;
    padding: 15px 0;
	}

	.info-table {
		width: 100%;
		border-collapse: collapse;
		margin-bottom: 20px;
		font-size: 25px;

		.info-th {
			width: 30%;
			padding: 12px;
			background-color: #f5f5f5;
			border: 1px solid #ddd;
			text-align: left;
			font-weight: 600;
		}

		.info-tr {
			&:nth-child(even) {
				background-color: #fafafa;
			}
		}

		.info-td {
			padding: 12px;
			border: 1px solid #ddd;
			color: #333;
		}
	}

	/* 签字区域样式优化 */
	.sign-section {
		margin: 30px 0;
		padding: 20px;
		border: 1px solid #e0e0e0;
		border-radius: 8px;
		background-color: #fafafa;

		/* 每一行的布局 */
		.sign-item {
			display: flex;
			align-items: center;
			margin-bottom: 20px;
			/* 最后一行取消底部间距 */
			&:last-child {
				margin-bottom: 0;
			}
		}

		/* 标签样式 */
		.sign-label {
			font-size: 25px;
			color: #333;
			width: 130px; /* 固定标签宽度，确保对齐 */
			text-align: right;
			padding-right: 15px;
			font-weight: 500;
		}

		/* 输入框容器 */
		.sign-input-wrapper {
			flex: 1; /* 占满剩余宽度 */
		}

		/* 输入框样式 */
		.sign-input {
			width: 100%; /* 输入框占满容器宽度 */
			padding: 10px 15px;
			border: 1px solid #ccc;
			border-radius: 4px;
			font-size: 22px;
			min-height: 42px; /* 确保足够高度 */
			box-sizing: border-box; /* 避免宽度溢出 */

			/* 日期输入框特殊处理 */
			&[type="date"] {
				padding: 8px 15px; /* 日期控件内边距调整 */
			}

			&::placeholder {
				color: #999;
				font-style: italic;
			}
		}
	}

	/* 提交按钮 */
	.submit-btn-container {
		margin-top: 20px;
		margin-bottom: 30px;
    &>div {
      margin-bottom: 20px;
    }
		//.submit-btn-clear {
    //
    //}
    //
    //.submit-btn-ok {
    //
    //}
	}
}
</style>
